const plans = [
  { name: "Free", key: "free_plan", tickerLimit: 5, priceMonthly: 0 },
  { name: "Basic", key: "basic_plan", tickerLimit: 25, priceMonthly: 25 },
  { name: "Plus", key: "plus_plan", tickerLimit: 50, priceMonthly: 50 },
  { name: "Core", key: "core_plan", tickerLimit: 100, priceMonthly: 100 },
  { name: "Pro", key: "pro_plan", tickerLimit: 150, priceMonthly: 150 },
  {
    name: "Master",
    key: "master_plan",
    tickerLimit: 200,
    priceMonthly: 200,
    includedAddons: ["signal_alerts"],
  },
];

export default plans;
